import {Component, Injector} from "@angular/core";
import {NotificationsDialogBaseComponent} from "./notifications-dialog-base/notifications-dialog-base.component";

@Component({
    selector: 'app-edit-notification',
    templateUrl: './notifications-dialog-base/notifications-dialog-base.component.html',
    styleUrls: ['./notifications-dialog-base/notifications-dialog-base.component.css'],
    standalone: false
})
export  class EditNotificationComponent extends NotificationsDialogBaseComponent{
  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editNotification";
  }

  public submit() {
    this.service.update(this.model).subscribe(() => {
        this.onCreated.emit();
        this.close();
        super.submit();
      });
  }
}
